import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

const rotateImage = keyframes`
100% {
    transform: rotate(360deg);
}`;

export const Container = styled.div`
  position: relative;
  margin: 0 auto;
`;

export const CircleLoading = styled.img`
  display: block;
  margin: 0 auto;
  width: 50px;
  height: 50px;
  -webkit-animation: ${rotateImage} 5s linear infinite;
  animation: ${rotateImage} 5s linear infinite;
  transform-origin: 50% 50%;
`;

export const Title = styled.h2`
  font-size: 24px;
  line-height: 32px;
  margin-top: 20px;
  color: #ffffff;
  white-space: pre;
  text-align: center;
`;

export const Text = styled.div`
  font-size: 16px;
  line-height: 24px;
  margin-top: 10px;
  color: #eeeeee;
  white-space: pre;
  text-align: center;
`;
